export const HIDE_MENU_LABEL = "Nascondi Menu";
export const SHOW_MENU_LABEL = "Mostra Menu";
export const DEVELOPMENT_LABEL = "Sviluppo";
export const PERFORMANCE_COACH_LABEL = "Performance Coach";
export const POTENTIAL_MATRIX_LABEL = "Matrice del Potenziale";
export const PERSONAL_PROFILE_LABEL = "Profilo Personale";
export const ABSTRACT_MYCAREER_LABEL = "Abstract myCareer";
export const AREA_DEVELOPMENT = "Area Development";
export const TECH_SKILLS_LABEL = "Competenze Tecniche";
export const TECH_SKILL_LABEL = "Competenza Tecnica";
export const COMPETENCE_LABEL = "Competenza";
export const ORGANIZATIONAL_CHART_LABEL = "Organigramma";
export const MANAGEMENT_LABEL = "Gestione";
export const PRODUCTION_LABEL = "Produzione";
export const EMPTY_STRING = "-";
export const DASHBOARD_LABEL = "Dashboard";
export const FAQS_LABEL = "FAQs";
export const FAQS_TITLE = "Hai bisogno di aiuto?";
export const FAQS_SUBTITLE =
  "Lorem ipsum dolor sit amet consectetur. Nibh pellentesque tortor amet feugiat varius natoque. Blandit ut nec ultricies dictumst nibh tristique sem tincidunt donec.";
export const PRIVACY_POLICY_LABEL = "Privacy Policy";
export const OTHER_PROFILES_LABEL = "Altri profili";
export const LOGOUT_LABEL = "Logout";
export const EXPERIENCE_LABEL = "Esperienza";
export const EXPERIENCES_LABEL = "Esperienze";
export const IN_ABSTRACT_LABEL = "In Abstract";
export const ACHIEVING_GOALS_LABEL = "Raggiungimento Obiettivi";
export const COMPARISON_OBJECTIVE_LABEL = "rispetto all’anno precedente";
export const FORMATION_LABEL = "Formazione";
export const COLLABORATORS_LABEL = "Collaboratori";
export const COLLABORATOR_LABEL = "Collaboratore";
export const ACTIVE_RESOURCES_LABEL = "Risorse Attive";
export const RESOURCES_LABEL = "Risorse";
export const FOLLOW_COLLABOLATORS_LABEL = "Seguiti";
export const COURSES_LABEL = "Corsi";
export const COURSE_LABEL = "Corso";
export const CERTIFICATIONS_LABEL = "Certificazioni";
export const CERTIFICATION_LABEL = "Certificazione";
export const EXTERNAL_COLLABORATOR = "Collaboratore Esterno";
export const ADD_EXTERNAL_COLLABORATOR = "Aggiungi Collaboratore Esterno";
export const EDIT_EXTERNAL_COLLABORATOR = "Modifica Collaboratore Esterno";
export const ADD_NEW_COURSE = "Aggiungi Nuovo Corso";
export const ADD_NEW_CERTIFICATION = "Aggiungi Nuova Certificazione";
export const NAME_SURNAME_EMAIL_LABEL = "Nome, cognome, e-mail";
export const FILTERS_LABEL = "Filtri";
export const RESET_FILTERS_LABEL = "Resetta filtri";
export const NAME_LABEL = "Nome";
export const SURNAME_LABEL = "Cognome";
export const FISCAL_CODE_LABEL = "Codice Fiscale";
export const EMAIL_LABEL = "E-mail";
export const PRACTICE_LABEL = "Practice";
export const CC_LABEL = "CC";
export const FORM_STATUS_CM_LABEL = "Stato Scheda CM";
export const CONFIRM_LABEL = "Conferma";
export const COMPANY_ORGANIZATION_LABEL = "Organizzazione aziendale";
export const COLLABORATIVE_RELATIONSHIP_LABEL = "Relazione collaborativa";
export const TIMELINE_LABEL = "Timeline";
export const FEATURES_LABEL = "Caratteristiche";
export const PC_STATUS_LABEL = "Stato PC";
export const CM_SHEET_LABEL = "Scheda CM";
export const SKILLS_TRAINING_LABEL = "Competenze";
export const SELECT_DATE_LABEL = "Seleziona Data";
export const EDIT_STATUS_LABEL = "Modifica stato";
export const SAVE_LABEL = "Salva";
export const CANCEL_LABEL = "Annulla";
export const EDIT_LABEL = "Modifica";
export const DELETE_LABEL = "Elimina";
export const TYPOLOGY_LABEL = "Tipologia";
export const DESCRIPTION_LABEL = "Descrizione";
export const SEND_FORM = "Invia scheda";
export const FORM_SENDING_LABEL = "Invio scheda";
export const FORM_SENDING_CONFIRM_MESSAGE =
  "Confermi di voler inviare la Scheda al Collaboratore per la Presa Visione?";
export const CURRENT_RESOURCES = "Organico attuale";
export const CONTEXT = "Contesto";
export const STRENGTHS = "Punti di forza";
export const IMPROVEMENT_ASSETS = "Asset di miglioramento";
export const DEVELOPMENT_SCENARIOS = "Scenario di sviluppo";
export const RESOURCES_NUMBER = "Numero risorse";
export const FORM_COMMENT = "Commento (Descrittivo)";
export const CM_PROPOSAL_LABEL = "Proposta";
export const FINAL_CALIBRATION_LABEL = "Valutazione Finale";
export const CAREER_DEVELOPMENT_COMMITTEE_LABEL =
  "Career Development Committee";
export const CM_STATE_EVALUATION_LABEL = "Valutazione";
export const PERCENT_REACHED_GOALS_LABEL = "Raggiungimento";
export const DEVELOPMENT_SCREEN_LABEL = "Quadrante di sviluppo";
export const EMPTY_DEVELOPMENT_SCREEN_LABEL = "Quadrante non definito";
export const A_LEGEND_LABEL = "High performer";
export const B_LEGEND_LABEL = "Crescita superiore alla media";
export const C_LEGEND_LABEL = "Crescita nella media";
export const D_LEGEND_LABEL = "Low performer";
export const TOOLTIP_MESSAGE =
  "Per inviare la scheda al collaboratore è necessario compilare le sezioni:";
export const INTERIM_TOOLTIP_MESSAGE =
  "Per portare la scheda allo stato successivo è necessario compilare le seguenti sezioni:";
export const EDIT_STATUS_TOOLTIP_MESSAGE =
  "Per cambiare lo stato è necessario completare le sezioni:";
export const EMPTY_STATE_COURSES_MESSAGE = "Nessun corso presente: creane uno";
export const EMPTY_STATE_CERTIFICATIONS_MESSAGE =
  "Nessuna certificazione presente: creane una";
export const EMPTY_STATE_TECH_SKILLS_MESSAGE =
  "Nessuna competenza tecnica presente: creane una";
export const EMPTY_STATE_SKILLS_MESSAGE =
  "Nessuna competenza presente: aggiungine una";
export const EMPTY_STATE_PERFORMANCE_COACH_MESSAGE =
  "Nessun Performance Coach presente";
export const EMPTY_STATE_PROJECTS_COLLABORATOR_MESSAGE =
  "Nessun progetto presente: aggiungine uno";
export const PROJECT_LABEL = "Progetto";
export const PERSONAL_DATA = "Dati Personali";
export const CONTRACT = "Contratto";
export const COMPANY_DATA = "Dati Aziendali";
export const CONTRACT_TYPE = "Tipo di Contratto";
export const COLLABORATION_START_DATE = "Data inizio collaborazione";
export const COLLABORATION_END_DATE = "Data fine collaborazione";
export const FIELD_IS_REQUIRED_LABEL = "Questo campo è obbligatorio";
export const MINIMUM_VALUE_LABEL = "Il valore deve essere maggiore di";
export const MAXIMUM_VALUE_LABEL = "Il valore deve essere minore di";
export const IS_REQUIRED_LABEL = "è obbligatorio";
export const IS_NOT_VALID_LABEL = "non è valido";
export const IS_NOT_VALID_URL_LABEL = "non è un URL valido";
export const DETAILS_LABEL = "Dettagli";
export const TITLE_LABEL = "Titolo";
export const DURATION_LABEL = "Durata";
export const EXECUTION_MODE_LABEL = "Modalità di esecuzione";
export const CATEGORY_LABEL = "Categoria";
export const URL_LABEL = "Url";
export const TARGETS_LABEL = "Destinatari";
export const INTERNAL_GRADE_IT_LABEL = "Livello Aziendale";
export const ASSIGN_LABEL = "Assegna";
export const ADD_NEW_TECH_SKILL = "Aggiungi Nuova Competenza Tecnica";
export const EDIT_TECH_SKILL = "Modifica Competenza Tecnica";
export const DELETE_TECH_SKILL_LABEL = "Elimina Competenza";
export const EDIT_COURSE_LABEL = "Modifica Corso";
export const DELETE_COURSE_LABEL = "Elimina Corso";
export const DELETE_TECH_SKILL_CONFIRM =
  "Confermi di voler eliminare la competenza tecnica";
export const DELETE_COURSE_CONFIRM_MESSAGE =
  "Confermi di voler eliminare il corso";
export const DELETE_PROJECT_CONFIRM_MESSAGE =
  "Confermi di voler eliminare il progetto";
export const DELETE_CERTIFICATION_CONFIRM_MESSAGE =
  "Confermi di voler eliminare la certificazione";
export const DELETE_COURSE_CERTIFICATE_CONFIRM_MESSAGE =
  "Confermi di voler eliminare l'attestato del corso";
export const DELETE_CERTIFICATION_CERTIFICATE_CONFIRM_MESSAGE =
  "Confermi di voler eliminare l'attestato della certificazione";
export const JOB_FAMILY_LABEL = "Job Family";
export const GRADE_LABEL = "Grade";
export const PATH_LABEL = "Path";
export const PATHS_LABEL = "Paths";
export const SUBGRADE_LABEL = "Subgrade";
export const SUBGRADES_LABEL = "Subgrades";
export const START_LABEL = "Partenza";
export const END_LABEL = "Proposta di arrivo";
export const EMPTY_COLLABORATORS_MESSAGE = "Nessun collaboratore trovato";
export const EMPTY_PERFORMANCE_COACH_MESSAGE =
  "Nessun Performance Coach trovato";
export const AVG_ACHIEVEMENT_LABEL = "Media Raggiungimento";
export const EMPTY_COURSES_MESSAGE = "Nessun corso trovato";
export const EMPTY_PROJECTS_MESSAGE = "Nessun progetto trovato";
export const EMPTY_CERTIFICATIONS_MESSAGE = "Nessuna certificazione trovata";
export const GROUP_TARGETS_LABEL = "Gruppi Destinatari";
export const EMPTY_TECH_SKILLS_MESSAGE = "Nessuna competenza tecnica trovata";
export const INTERNAL_GRADE_LABEL = "Internal Grade";
export const PROFESSIONAL_PATH_LABEL = "Percorso Professionale";
export const COLLABORATOR_COMMENT_LABEL = "Commento del Collaboratore";
export const COLLABORATOR_FEEDBACK_LABEL = "Indicazione del Collaboratore";
export const FEEDBACK_FOR_COLLABORATORATOR_LABEL = "Feedback al Collaboratore";
export const FINAL_INTERVIEW_LABEL = "Colloquio finale";
export const ADMIN_COMMENTS_LABEL = "Commenti Admin";
export const DEVELOPMENT_COMMENTS_LABEL = "Commento Development";
export const CM_SHEET_SENT_LABEL = "Scheda inviata";
export const HR_ADMIN_INTERVIEW_LABEL = "Colloquio HR e Admin";
export const HR_INTERVIEW_LABEL = "Colloquio HR";
export const NOTE_LABEL = "Note";
export const MODAL_CHANGE_STEPS_LABEL = "Modifica lo stato della scheda CM";
export const ACTION_PLAN_LABEL = "Piano di azione";
export const FOCUS_GOAL_LABEL = "Focus obiettivo di sviluppo";
export const PROFESSIONAL_HISTORY_LABEL = "Storia Professionale";
export const RESUME_LABEL = "Resume";
export const CM_STATE_PLANNING_LABEL = "Pianificazione";
export const CM_STATE_PROGRESS_LABEL = "Avanzamento";
export const SHEET_COMPLETED_LABEL = "Scheda completata";
export const CM_STATE_FINAL_CONSIDERATIONS_LABEL = "Considerazioni finali";
export const CM_STATE_SHEET_ARCHIVED_LABEL = "Archiviazione";
export const CM_STATE_SHEET_ARCHIVED_WITH_TERMINATION_LABEL =
  "Scheda archiviata con cessazione";
export const DATA_SAVED_SUCCESS_LABEL = "Dati salvati correttamente";
export const ITEMS_ADDED_SUCCESS_LABEL = "Elementi aggiunti correttamente";
export const DATA_ADDED_SUCCESS_LABEL = "Elemento aggiunto correttamente";
export const DATA_UPDATED_SUCCESS_LABEL = "Modifica effettuata correttamente";
export const CERTIFICATE_ADDED_SUCCESS_LABEL =
  "Attestato aggiunto correttamente";
export const DATA_DELETED_SUCCESS_LABEL =
  "Eliminazione effettuata correttamente";
export const ERROR_LABEL = "Errore";
export const ERROR_MESSAGE_LABEL = "Errore interno. Contattare l'assistenza.";
export const GOALS_LABEL = "Obiettivi";
export const GOALS_TOOLTIP_LABEL = "Obiettivi (Tutti)";
export const GOALS_TOOLTIP_2_LABEL = "Obiettivi (% raggiungimento)";
export const SOFT_SKILLS_LABEL = "Soft Skills";
export const SOFT_SKILL_LABEL = "Soft Skill";
export const JOB_FAMILIES = "Job Families";
export const GRADES_PATHS = "Grades & Paths";
export const DIMENSIONS_LABEL = "Dimensioni";
export const DIMENSION_LABEL = "Dimensione";
export const LEVELS_LABEL = "Livelli";
export const LEVEL_LABEL = "Livello";
export const INITIALS_LABEL = "Sigla";
export const ORDER_LABEL = "Ordine";
export const EMPTY_COURSES_SELECTED_LABEL =
  "Aggiungi i corsi da includere nel percorso formativo";
export const EMPTY_CERTIFICATIONS_SELECTED_LABEL =
  "Aggiungi le informazioni sulle certificazioni da conseguire nel percorso formativo";
export const ADD_COURSE_LABEL = "Aggiungi corso";
export const DELETE_COURSES_LABEL = "Elimina corso";
export const DELETE_COURSE_BODY_LABEL_1 =
  "Confermi di voler eliminare il corso";
export const DELETE_COURSE_BODY_LABEL_2 = "dalla lista dei corsi assegnati a";
export const DELETE_CERTIFICATION_BODY_LABEL_1 =
  "Confermi di voler eliminare la certificazione ";
export const DELETE_CERTIFICATION_BODY_LABEL_2 =
  " dalla lista delle certificazioni assegnati a ";
export const COMPLETED_LABEL = "Completato";
export const IN_PROGRESS_LABEL = "In corso";
export const VALIDITY_LABEL = "Validità";
export const VALIDITY_EXPIRATION_LABEL = "Scadenza validità";
export const EXPIRATION_DATE_LABEL = "Data di scadenza";
export const DATE_ACHIEVEMENT_LABEL = "Data conseguimento";
export const STATE_LABEL = "Stato";
export const UPLOAD_COURSE_CERTIFICATE_LABEL = "Carica Attestato Corso";
export const EDIT_COURSE_CERTIFICATE_LABEL = "Modifica Attestato Corso";
export const DELETE_CERTIFICATE_LABEL = "Elimina attestato";
export const COURSE_CERTIFICATE_LABEL = "Attestato Corso";
export const DELETE_PROJECT_LABEL = "Elimina Progetto";
export const CERTIFICATION_CERTIFICATE_LABEL = "Attestato Certificazione";
export const EDIT_CERTIFICATION_LABEL = "Modifica Certificazione";
export const TO_ACHIEVE_LABEL = "Da conseguire";
export const VALID_LABEL = "Valida";
export const EXPIRED_LABEL = "Scaduta";
export const ADD_CERTIFICATIONS_LABEL = "Aggiungi certificazione";
export const START_DATE_LABEL = "Data di partenza: ";
export const CUSTOM_LABEL = "Personalizzato";
export const COMPANY_LABEL = "Aziendale";
export const FORMATION_COURSE_LABEL = "Corso Formativo";
export const LANGUAGE_COURSE_LABEL = "Corso di Lingua";
export const TECH_COURSE_LABEL = "Corso Tecnico";
export const PATH_COURSE_LABEL = "Percorso";
export const PRESENCE_LABEL = "Presenza";
export const REMOTE_LABEL = "Remoto";
export const COMMUNICATION_CERTIFICATION_LABEL = "Comunicazione";
export const LANGUAGE_LABEL = "Lingua";
export const IT_CERTIFICATION_LABEL = "IT";
export const MANAGEMENT_CERTIFICATION_LABEL = "Management";
export const LEVEL_OF_SATISFACTION_LABEL = "Livello di soddisfazione";
export const EVALUATION_LEVEL_LABEL = "Livello Valutazione";
export const UPLOAD_FILE_1_LABEL = "Clicca qui ";
export const UPLOAD_FILE_2_LABEL =
  " o trascina il file per caricare l'attestato";
export const UPLOAD_FILE_SUBTITLE_LABEL = "Massimo 5 mb";
export const UPLOAD_FILE_ERROR_DIMENSION_LABEL =
  "File troppo grande. La dimensione massima è 5 mb.";
export const MB_LABEL = "MB";
export const UPLOAD_FILE_ERROR_TYPE_LABEL =
  "Solo i file .pdf possono essere caricati.";
export const PERCENTAGE_LABEL = "Percentuale";
export const EMPTY_PERCENTAGE_LABEL = "Percentuale non ancora disponibile";
export const HR_COMMENT_LABEL = "Commento HR";
export const PERFORMANCE_COMMENT_LABEL = "Commento Performance";
export const ADMIN_COMMENT_LABEL = "Commento Admin";
export const FINAL_INTERVIEW_PC_LABEL = "Commento finale del PC";
export const CM_SHEET_VISION_LABEL = "Presa Visione Scheda CM";
export const CM_SHEET_ARCHIVING_WARNING_MESSAGE =
  "Le schede CM non possono essere archiviate finché i collaboratori indicati in tabella non ne avranno preso visione.";
export const WAITING_FOR_VISION_LABEL = "In attesa della Presa Visione";
export const HAVING_VISION_LABEL = "Presa visione completata";
export const SEND_REMINDER_LABEL = "Invia Sollecito";
export const SEND_VISION_REMINDER_LABEL = "Invia Sollecito Presa Visione";
export const CM_SHEETS_READY_FOR_ARCHIVING_LABEL =
  "Schede CM pronte per essere archiviate";
export const CM_SHEETS_ARCHIVED_LABEL = "Schede CM archiviate correttamente";
export const CM_SHEETS_ARCHIVING_CONFIRM_MESSAGE =
  "Confermi di voler archiviare le Schede CM di";
export const MESSAGE_TOOLTIP_FINAL_INTERVIEW_LABEL =
  "Per procedere è necessario inserire la percentuale di raggiungimento degli obiettivi nella sezione 3 “Obiettivi”.";
export const CM_SHEETS_VISION_REQUIRED_TOOLTIP =
  "Le schede CM non possono essere archiviate finché tutti i collaboratori non le hanno visionate. Inviare un sollecito per la presa visione.";
export const CM_SHEETS_REMINDER_ALREADY_SENT_TOOLTIP =
  "Sollecito già inviato. Non è possibile inviarne altri al momento. Si prega di attendere che tutti i collaboratori abbiano preso visione della Scheda CM.";
export const ROLE_LABEL = "Ruolo";
export const CM_SHEET_ARCHIVING_LABEL = "Archiviazione Schede CM";
export const FORMS_LABEL = "Schede";
export const FORM_LABEL = "Scheda";
export const CM_LABEL = "Career Management";
export const WRITE_A_NOTE_LABEL = "Inserisci una nota.";
export const DELETE_NOTE_LABEL = "Elimina nota";
export const EDIT_REGISTRY_LABEL = "Modifica Anagrafica";
export const NAME_SURNAME_LABEL = "Nome e Cognome";
export const DELETE_CERTIFICATION_LABEL = "Elimina Certificazione";
export const RECOMMEND_LABEL = "Consiglia";
export const MONTH_LABEL = "Mese";
export const MONTHS_LABEL = "Mesi";
export const EXPIRED_CERTIFICATION_LABEL = "Certificazione Scaduta";
export const HOURS_LABEL = "Ore";
export const PERFORMANCE_COACH_COLLABORATORS_LABEL =
  "Collaboratori Associati al Performance Coach";
export const COMPETENCE_CENTER_LABEL = "Competence Center";
export const ACTUAL_PROJECT_LABEL = "PROGETTI ATTUALI";
export const ASSIGNED_GOAL_LABEL = "OBIETTIVI ASSEGNATI";
export const COLLABORATOR_SATISFACTION_LABEL =
  "SODDISFAZIONE DEL COLLABORATORE";
export const COMMENT_OF_PC_LABEL = "COMMENTO DEL PERFORMANCE COACH";
export const PROGRESS_PLAN_LABEL = "PIANO DI SVILUPPO E AVANZAMENTO";
export const PRINT_LABEL = "Stampa";
export const PROPOSAL_STEPS_INCREASER_LABEL = "Proposta, passaggi e aumenti";
export const PERCENTAGE_ACHIEVEMENTS_GOALS_LABEL =
  "Percentuale di raggiungimento degli obiettivi";
export const ACHIEVEMENTS_GOALS_LABEL = "Raggiungimento degli obiettivi";
export const PROFESSIONAL_PORTRAIT_LABEL = "Ritratto Professionale";
export const PROJECTS_LABEL = "Progetti";
export const COLLABORATOR_PROFILE_LABEL = "Profilo del Collaboratore";
export const HEADQUARTERS_LABEL = "Sede";
export const HIRE_DATE_LABEL = "Data Assunzione";
export const TERMINATION_DATE_LABEL = "Data Cessazione";
export const PC_HISTORY = "Storico PC";
export const PROFESSIONAL_DATA_LABEL = "Dati Professionali";
export const CV_LABEL = "CV";
export const LINKEDIN_PROFILE_LABEL = "Profilo Linkedin";
export const LINKEDIN_LABEL = "Linkedin";
export const YEARS_OF_EXPERIENCE = "Anni di esperienza";
export const YEARS_IN_ABSTRACT = "Anni in Abstract";
export const STARTING_DATE_LABEL = "Data Inizio";
export const ENDING_DATE_LABEL = "Data Fine";
export const EDIT_PC_LABEL = "Modifica PC";
export const ASSIGN_PC_LABEL = "Assegna Performance Coach";
export const SEARCH_PERFORMANCE_COACH = "Cerca Performance Coach";
export const CURRICULUM_LABEL = "Curriculum";
export const ADD_SKILL_LABEL = "Aggiungi Competenza";
export const ATTENDANCE_YEAR_LABEL = "Anno Frequenza";
export const COURSE_NAME_LABEL = "Nome Corso";
export const CERTIFICATION_NAME_LABEL = "Nome Certificazione";
export const EXPIRING_LABEL = "In Scadenza";
export const CERTIFICATE_LABEL = "Attestato";
export const YEAR_LABEL = "Anno";
export const ADD_PROJECT_LABEL = "Aggiungi Progetto";
export const EDIT_PROJECT_LABEL = "Modifica Progetto";
export const CONCLUDED_LABEL = "Concluso";
export const DELETE_GRADE_LABEL = "Elimina grade";
export const DELETE_PATH_LABEL = "Elimina path";
export const DELETE_ITEM_LABEL = "Elimina componente";
export const DELETE_ITEM_MODAL_LABEL =
  "Sei sicuro di voler eliminare questo elemento: ";
export const DELETE_GRADE_1_LABEL = "Sei sicuro di voler eliminare il grade ";
export const DELETE_PATH_1_LABEL = "Sei sicuro di voler eliminare il path ";
export const DELETE_GRADE_PATH_2_LABEL = " e gli elementi ad esso subordinati?";
export const CREATE_ELEMENT_LABEL = " Crea Elemento";
export const DELETE_PATH_GRADE_LABEL =
  "Sei sicuro di voler eliminare questo elemento? ";
export const DELETE_PATH_GRADE_NAME_MODAL_LABEL = "Elimina grade";
export const YEARS_LABEL = "Anni";
export const EDIT_ASSIGN_PC_LABEL = "Modifica Performance Coach";
export const STARS_LABEL = "Stelle";
export const FILE_LABLE = "File";
export const PREVIOUS_PAGE_LABLE = "Pagina precedente";
export const NEXT_PAGE_LABLE = "Pagina successiva";
export const DELETE_EXERNAL_COLLABORATOR_LABEL =
  "Elimina Collaboratore Esterno";
export const DELETE_CONFIRM_MESSAGE =
  "Sei sicuro di voler eliminare il collaboratore esterno";
export const EMPTY_CURRICULUM_MESSAGE = "Nessun Curriculum trovato";
export const CREATE_CM_SHEETS_LABEL = "Crea Schede CM";
export const CREATE_CM_SHEETS_MESSAGE =
  "Sei sicuro di voler creare le schede CM con questa configurazione?";
export const HOUR_LABEL = "Ora";
export const DAY_LABEL = "Giorno";
export const WEEK_LABEL = "Settimana";
export const DAYS_LABEL = "Giorni";
export const WEEKS_LABEL = "Settimane";
export const NO_DATA_LABEL =
  "Non ci sono dati, cliccare il bottone `Modifica` per aggiungerli";
export const SELECT_COLLABORATOR_LABEL = "Selezionare un collaboratore";
export const SELECT_ONE_COLLABORATOR_LABEL =
  "Selezionare massimo un collaboratore";
export const CM_SHEETS_CREATION_IN_PROGRESS_LABEL =
  "Creazione schede CM in corso...";
export const CM_SHEETS_CREATION_ERROR_LABEL =
  "Errore nella creazione delle schede CM";
export const CONTACT_TECHNICAL_SUPPORT = "Contattare l'assistenza tecnica";
export const ERROR_RANGE_MESSAGE_LABEL =
  "Assicurati che l'intero range 0%-100% sia coperto senza interruzioni e che non ci siano sovrapposizioni tra i valori.";
export const OK_LABEL = "OK";
export const OTHER_LABEL = "Altro";
export const ALL_LABEL = "Tutto";
export const WEIGHTING_PERCENTAGE_LABEL = "Ponderazione (%)";
export const GOAL_LABEL = "Obiettivo";
export const FILL_IN_LABEL = "Compila";
export const EMPTY_INTERNAL_GRADE_MESSAGE =
  "Assegna il livello di partenza e il livello di arrivo";
export const RESET_DEVELOPMENT_INDICATORS_CONFIRM_MESSAGE =
  "La modifica dell’Internal Grade di partenza aggiornerà gli indicatori nella sezione “Development – Indicatori” e cancellerà definitivamente le valorizzazioni già inserite. Vuoi procedere?";
export const RESET_DEVELOPMENT_INDICATORS_CONFIRM_LABEL =
  "Eliminazione dati sezione Development";
export const EMPTY_SOFT_SKILLS_MESSAGE =
  "Assegna il livello relativo a ciascuna Soft Skill";
export const EMPTY_GOALS_MESSAGE =
  "Aggiungi e descrivi gli obiettivi ponderandone il peso complessivo";
export const EMPTY_PROFESSIONAL_PATH_MESSAGE =
  "Definisci il focus dell'obiettivo di sviluppo e il piano d'azione";
export const ALL_PLURAL_LABEL = "Tutti";
export const VIEW_LABEL = "Vedi";
export const CLOSE_LABEL = "Chiudi";
export const EMPTY_COLLABORATOR_COMMENT_MESSAGE =
  "Aggiungi il livello di soddisfazione e il commento del Collaboratore";
export const EMPTY_FINAL_INTERVIEW_MESSAGE =
  "Commenta l'esito del percorso formativo e definisci il quadrante di sviluppo";
export const EMPTY_ADMIN_COMMENT_MESSAGE =
  "Aggiungi il commento Development e il commento Performance";
export const EMPTY_DEVELOPMENT_COMMENT_MESSAGE =
  "Aggiungi il commento Development";
export const EMPTY_NOTES_MESSAGE = "Scrivi e visualizza note";
export const ADD_LABEL = "Aggiungi";
export const EMPTY_CM_SHEET_MESSAGE =
  "Per questo collaboratore non è prevista la Scheda CM.";
export const ACHIEVEMENT_PERCENTAGE_DISABLED_TOOLTIP =
  "Si abilita quando la scheda passa allo stato “Avanzamento”";
export const ACHIEVEMENT_PERCENTAGE_ENABLED_TOOLTIP =
  "La media raggiungimento è calcolata ponderando l'impatto delle challenge per ogni obiettivo.";
export const MAX_GOALS_CM_SHEET_MESSAGE =
  "È possibile aggiungere fino a un massimo di 5 obiettivi.";
export const CONFIRM_CM_SHEET_LABEL = "Conferma scheda CM";
export const CONFIRM_CM_SHEET_MESSAGE =
  "Cliccando sul tasto 'Conferma Scheda CM' accetti e confermi tutti i dati visualizzati.";
export const CM_SHEET_CONFIRMED_LABEL = "Scheda CM confermata";
export const RESTORE_LABEL = "Ripristina";
export const SCOPE_LABEL = "Ambito";
export const CORE_COMPETENCE_LABEL = "Competenza Core";
export const SUB_COMPETENCE_LABEL = "Sotto Competenza";
export const RESTORE_MESSAGE =
  "Sei sicuro di voler ripristinare la Scheda allo stato";
export const RESTORE_CM_SHEET_LABEL = "Ripristina Scheda";
export const CM_SHEET_ARHIEVED_WITH_TERMINATION_MESSAGE =
  "La Scheda CM è stata archiviata a seguito di cessazione.";
export const CM_SHEET_NOT_ACCESSIBLE_MESSAGE =
  "La Scheda CM non è accessibile.";
export const RESULTS_LABEL = "Risultati";
export const RECIPIENT_LABEL = "Destinario";
export const FINAL_INTERVIEW_DIMENSION_MESSAGE_TOOLTIP =
  "Per procedere è necessario inserire la percentuale di raggiungimento degli obiettivi nella sezione 3 “Obiettivi”.";
export const EDITING_MODAL_MESSAGE_TOOLTIP =
  "Stai per uscire da questa sezione. Se non salvi le modifiche, i dati inseriti andranno persi.\nVuoi procedere senza salvare?";
export const EDITING_MODAL_LABEL_TOOLTIP = "Vuoi procedere senza salvare?";
export const LANGUAGE_SKILL_LABEL = "Competenza Linguistica";
export const LANGUAGE_SKILLS_LABEL = "Competenze Linguistiche";
export const ADD_LANGUAGES_SKILLS_LABEL = "Aggiungi Competenza Linguistica";
export const NATIVE_LANGUAGE_LABEL = "Lingua Madre";
export const SKILLS_LABEL = "Competenze";
export const LINGUISTIC_LABEL = "Linguistiche";
export const TECHS_LABEL = "Tecniche";
export const EMPTY_SKILL_LANGUAGE_MESSAGE =
  "Nessuna competenza linguistica presente";
export const LISTENING_LABEL = "Ascolto";
export const READING_LABEL = "Lettura";
export const INTERACTION_LABEL = "Interaction";
export const SPOKEN_PRODUCTION = "Produzione orale";
export const EMPTY_COLLABORATOR_TECH_SKILLS_MESSAGE =
  "Associa una o piu competenze tecniche";
export const DELETE_LANGUAGE_LABEL = "Elimina Lingua";
export const DELETE_LANGUAGE_CONFIRM = "Confermi di voler eliminare la lingua";
export const EDIT_LANGUAGES_SKILLS_LABEL = "Modifica Competenza Linguistica";
export const COMPREHENSION_LABEL = "Comprensione";
export const SPOKEN_LABEL = "Parlato";
export const WRITTEN_LABEL = "Scritto";
export const VERIFICATION_STATUS_LABEL = "Stato di Verifica";
export const SEARCH_LABEL = "Cerca";
export const TECH_SKILL_DUPLICATE_ENTITY_ERROR_MESSAGE =
  "Attenzione! Esiste già una competenza con i dati inseriti. Modificare uno o più elementi per salvarne una nuova.";
export const TECH_SKILL_DUPLICATE_PROP_ERROR_MESSAGE =
  "Valore già esistente in un'altra proprietà";
export const NO_RESULT_FOUND_LABEL = "Nessun risultato trovato";
export const ARCHIVING_LABEL = "Archiviazione";
export const FINAL_CONSIDERATIONS_PENDING_LABEL =
  "In attesa di Considerazioni finali";
export const READY_SEND_SHEET_LABEL = "Pronti per Invio scheda";
export const PC_ABBREVIATION_LABEL = "PC";
export const EMPTY_ARCHIVED_PENDING_MESSEGE =
  "Nessuna scheda è in attesa di passare allo stato “Considerazioni finali”";
export const EMPTY_READY_SEND_SHEET_MESSEGE =
  "Non sono presenti schede in stato “Considerazioni finali” da inviare";
export const FORM_STATUS_LABEL = "Stato Scheda";
export const ATTACH_TECH_SKILL = "Associa Competenza Tecnica";
export const PC_URGES_LABEL = "Sollecita i PC";
export const CM_URGES_SENDED_LABEL = "Sollecito giornaliero inviato";
export const NUMBER_CM_URGES_SENDED_LABEL = "Solleciti inviati:";
export const PC_URGES_MESSAGE =
  "Sollecita i PC a inviare la Scheda CM ai Collaboratori per la presa visione. Puoi inviare un sollecito al giorno.";
export const PC_URGES_MESSAGE_TOOLTIP =
  "Confermi di voler sollecitare i PC ad inviare la Scheda CM ai Collaboratori per la presa visione?";
export const EDIT_LINKEDIN_LABEL = "Modifica Profilo Linkedin";
export const ADD_LINKEDIN_LABEL = "Aggiungi Profilo Linkedin";
export const DATA_NOT_AVAILABLE_INSIDE_CV = "Dato non presente nel CV";
export const EMPTY_PAST_EXPERIENCES_MESSAGE = "Nessuna esperienza trovata";
export const READY_TO_SEND_LABEL = "PRONTA PER L'INVIO";
export const TO_VERIFY_LABEL = "DA VERIFICARE";
export const EMPTY_ARCHIVE_ALL_SHEETS_MESSEGE =
  "Invio completato: clicca Archivia per spostare le schede in archivio.";
export const CM_SHEET_ARCHIVING_MESSEGE_1 =
  "Confermi di voler archiviare le Schede CM di";
export const NO_CM_SHEETS_TO_ARCHIVE_MESSEGE =
  "Tutte le schede sono state archiviate correttamente";
export const EMPTY_ATTACHMENTS_MESSAGE = "Nessuna competenza associata";
export const DETACH_TECH_SKILL = "Dissocia Competenza Tecnica";
export const DETACH_TECH_SKILL_MESSAGE =
  "Confermi di voler dissociare la competenza tecnica";
export const EDIT_LEVEL_TECH_SKILL = "Modifica Livello Competenza Tecnica";
export const IMPERSONATE_LABEL = "Impersonate";
export const SEARCH_USER_LABEL = "Cerca utente";
export const NOTIFICATIONS_LABEL = "Notifiche";
export const MARK_ALL_AS_READ_LABEL = "Segna tutte come lette";
export const NOTIFICATION_SEARCH_LABEL = "Cerca notifica...";
export const ALL_NOTIFICATIONS_LABEL = "Tutte";
export const UNREAD_NOTIFICATIONS_LABEL = "Non lette";
export const READ_NOTIFICATIONS_LABEL = "Lette";
export const PROCESSING_ARCHIVING_MESSAGE =
  "L’elaborazione potrebbe richiedere alcuni minuti. Ti chiediamo di non chiudere o aggiornare questa finestra fino al completamento.";
export const SHOW_MORE_LABEL = "Mostra altro";
export const SHOW_LESS_LABEL = "Mostra meno";
export const NO_NOTIFICATION_FOUND_LABEL = "Nessuna notifica da mostrare";
export const CHANGE_DESTINATION_ALERT_MESSAGE =
  "Attenzione! Stai modificando i destinatari.";
export const PERSONAL_ACCOUNT_LABEL = "Account Personale";
export const ACCESS_DENIED_LABEL = "Accesso negato";
export const ERROR_403_MESSAGE_P1_LABEL =
  "L’utenza non è abilitata all'uso dell'applicazione.";
export const ERROR_403_MESSAGE_P2_LABEL =
  "Per maggiori informazioni contatta il nostro team all’indirizzo:";
export const COME_BACK_LABEL = "Torna indietro";
export const MAINTENANCE_TITLE_LABEL = "Servizio in manutenzione";
export const MAINTENANCE_MESSAGE_LABEL =
  "Il servizio è temporaneamente non disponibile. Stiamo lavorando per ripristinarlo il prima possibile.";
export const RETRY_LABEL = "Riprova";
export const START_CALIBRATION_LABEL = "Start Calibration";
export const DOWNLOAD_LABEL = "Download";
export const EVALUATION_LABEL = "IN VALUTAZIONE";
export const EVALUATION_COLLABORATORS_LABEL = "Collaboratori da esaminare";
export const EVALUATION_COLLABORATORS_EMPTY_MESSAGE =
  "Seleziona un Performance Coach per visualizzare i Collaboratori associati";
export const TO_BE_EXAMINED_LABEL = "DA ESAMINARE";
export const EXAMINED_LABEL = "ESAMINATI";
export const NO_COLLABORATORS_EXAMINED_MESSAGE =
  "Nessun collaboratore esaminato";
export const NOTHING_TO_ARCHIVE_LABEL = "Nessuna scheda CM presente";
export const COMPANY_NAME_LABEL = "Nome Azienda";
export const EDIT_EXPERIENCE_LABEL = "Modifica Esperienza";
export const ADD_EXPERIENCE_LABEL = "Aggiungi Esperienza";
export const DELETE_EXPERIENCE_LABEL = "Elimina Esperienza";
export const DELETE_EXPERIENCE_CONFIRM =
  "Confermi di voler eliminare l'esperienza";
export const RELEASE_HERE_LABEL = "Rilascia qui";
export const PROGRESS_STATUS_LABEL = "Stato di avanzamento";
export const CORPORATION_LABEL = "Azienda";
export const SECTOR_NAME_LABEL = "Settore";
export const CUSTOMER_NAME_LABEL = "Cliente";
export const ACTIVITIES_PERFORMED_NAME_LABEL = "Attività";
export const RESOURSES_POOL_NAME_LABEL = "Strumenti";
export const PROJECT_NAME_LABEL = "Nome progetto";
export const PLACEHOLDER_DESCRIPTION_LABEL =
  "Descrizione (Esigenza + Soluzione)";
export const PLACEHOLDER_ACTIVITIES_PERFORMED_LABEL =
  "Attività (Attività svolte)";
export const PLACEHOLDER_TOOLS_NAME_LABEL =
  "Strumenti (Competenze e Tecnologie)";
export const ABSTRACT_LABEL = "Abstract";
export const INSTRUCTION_LABEL = "Istruzione";
export const EMPTY_INSTRUCTION_MESSAGE =
  "Nessun titolo di studio presente: aggiungine uno";
export const EDUCATIONAL_QUALIFICATION_LABEL = "Titolo di studio";
export const EDUCATIONAL_QUALIFICATIONS_LABEL = "Titoli di studio";
export const ADD_INSTRUCTION_LABEL = "Aggiungi Titolo di studio";
export const NAME_EDUCATIONAL_QUALIFICATION_LABEL = "Nome Titolo di studio";
export const EDIT_INSTRUCTION_LABEL = "Modifica Titolo di studio";
export const EDUCATIONAL_INSTITUTION_LABEL = "Ente di istruzione";
export const STUDY_PATH_LABEL = "Percorso di studio";
export const EMPTY_EDUCATIONAL_QUALIFICATION_MESSAGE =
  "Nessun titolo di studio trovato";
export const DELETE_EDUCATIONAL_QUALIFICATION_LABEL =
  "Elimina Titolo di Studio";
export const DELETE_EDUCATIONAL_QUALIFICATION_BODY_LABEL =
  "Confermi di voler eliminare il titolo di studio";
export const EDUCATIONAL_LABEL = "Ente";
export const YEAR_START_LABEL = "Anno inizio";
export const YEAR_END_LABEL = "Anno fine";
export const DIPLOMA_LABEL = "Diploma";
export const DEGREE_LABEL = "Laurea";
export const MASTER_DEGREE_LABEL = "Laurea Magistrale";
export const MASTER_LABEL = "Master";
export const DOCTORATE_LABEL = "Dottorato";
export const TODAY_LABEL = "Ad oggi";
export const COLLABORATOR_REVIEW_MESSAGE =
  "Desideri riesaminare il collaboratore";
export const COLLABORATOR_REVIEW_LABEL = "Riesamina collaboratore";
export const NO_CONFIG_LABEL = "Nessuna configurazione presente";
export const CONFIRM_CALIBRATION_FINAL =
  "Conferma uscita dalla Calibration Finale";
export const CONFIRM_CALIBRATION_FINAL_MESSAGE =
  "Sei sicuro di voler uscire dalla calibration finale?";
export const INVALID_STEP_VALUE_LABEL =
  "Il valore deve essere un multiplo di 5";
export const EXPERIENCE_START_DATE_ERROR_MESSAGE =
  "Il range di date selezionate è fuori dall'intervallo di date di alcuni progetti associati.";
export const EXPERIENCE_DELETE_ERROR_MESSAGE =
  "non può essere cancellata perchè ci sono dei progetti associati.";
export const EXPERIENCE_OVERLAP_ERROR_MESSAGE =
  "Per il range di date selezionate esiste già un'esperienza in Abstract";
export const CONFIRM_TO_PC_LABEL = "Sottoponi a PC";
export const APPROVED_CV_LABEL = "Approva CV";
export const APPROVED_CV_CONFIRMATION_MESSAGE =
  "Cliccando sul tasto 'Approva CV', approvi che tutti i dati inseriti dal collaboratore sono corretti. Vuoi procedere?";
export const CONFIRM_VALID_LABEL = "Conferma validità";
export const SEND_PROFILE_TO_PC = " Invia profilo al PC ";
export const SUBMIT_TO_PC_CONFRIMATION_MESSAGE =
  "Cliccando su 'Sottoponi al PC', il tuo profilo verrà inviato al tuo Performance Coach per la revisione. Vuoi procedere?";
export const DOWNLOAD_CV_LABEL = "Download CV";
export const CONFIRM_DOWNLOAD_LABEL = "Conferma Download";
export const CURRICULUM_VITAE_LABEL = "Curriculum Vitae";
export const DOWNLOAD_FORMAT_LABEL = "Formato Download CV";
export const DOWNLOAD_IT_LABEL = "Scarica";
export const COLLABORATOR_SELECTED_LABEL = "Collaboratore selezionato";
export const COLLABORATORS_SELECTED_LABEL = "Collaboratori selezionati";
export const CV_STATUS_LABEL = "Stato CV";
export const FINAL_CALIBRATION_ERROR_START =
  "In fase di calibration finale è stato indicato un raggiungimento del";
export const FINAL_CALIBRATION_ERROR_END =
  ". È necessario aggiornare i valori prima dell'invio della scheda";
export const ASSISTANCE_LABEL = "Assistenza";
export const LABEL_TOOLTIP_A_POTENTIAL_MATRIX =
  "Very high potential e competenze distintive di ruolo molto sopra la media";
export const LABEL_TOOLTIP_B_POTENTIAL_MATRIX =
  "High potential e competenze di ruolo in media o sopra la media";
export const LABEL_TOOLTIP_C_POTENTIAL_MATRIX =
  "In ruolo, competenze in media o leggermente sopra la media, stabile nel ruolo";
export const LABEL_TOOLTIP_D_POTENTIAL_MATRIX =
  "Fuori ruolo o ruolo da correggere, competenze sopra la media";
export const INVALID_DATE_LABEL = "Data non valida";
export const MUST_BE_AFTER_THAN_LABEL = "deve essere successiva alla";
export const MUST_BE_WITHIN_EXPERIENCE_LABEL =
  "deve rientrare nel periodo dell'esperienza selezionata";
export const DELETE_ASSIGN_PC_LABEL = "Elimina PC assegnato";
export const WAITING_CAREER_PERFORMANCE_COMMITTEE_LABEL =
  "In attesa di Career Performance Committee";
export const CLICK_ACTION_LABEL = "Clicca";
export const USE_MANUAL_INFO_MESSAGE = "per approfondire nel manuale d'uso";
export const GLOBAL_LABEL = "Globale";
export const TIME_LABEL = "Time";
export const CONTEST_LABEL = "Context";
export const ACTION_LABEL = "Action";
export const IMPACT_LABEL = "Impatto";
export const EMPTY_IMPACT_LABEL = "Impatto non ancora disponibile";
export const NO_IMPACT_LABEL = "Non Rilevata";
export const LOW_IMPACT_LABEL = "Basso";
export const MEDIUM_IMPACT_LABEL = "Medio";
export const HIGH_IMPACT_LABEL = "Alto";
export const ACTION_TOOLTIP =
  "Misura il livello di autonomia decisionale e complessità delle scelte richieste.";
export const CONTEST_TOOLTIP =
  "Valuta la complessità dell’ambiente interno ed esterno in cui si opera.";
export const TIME_TOOLTIP =
  "Misura la pressione temporale e la gestione delle priorità.";
export const IMPACT_TOOLTIP =
  "Somma del livello di complessità delle challenge.";
export const PERCENT_REACHED_GOALS_TOOLTIP =
  "Percentuale di raggiungimento degli obiettivi.";
export const DEVELOPMENT_TITLE_LABEL = "Development";
export const BEHAVIORAL_INDICATORS_LABEL = "Indicatori di Comportamento";
export const COMMENT_SENT_DEVELOPMENT_SECTION_LABEL =
  "Il commento sarà inviato alla sezione Development";
export const SEND_COMMENT_LABEL = "Invia commento";
export const SEND_COMMENT_DEVELOPMENT_MODAL_TITLE =
  "Invio commento Development";
export const SEND_COMMENT_DEVELOPMENT_MODAL_MESSAGE =
  "Sei sicuro di voler inviare il commento al Development? Dopo l'invio non potrà più essere modificato.";
export const SUBMITTED_COMMENT_DEVELOPMENT_LABEL =
  "Commento inviato al Development";
export const SEND_ADMIN_COMMENT_DEVELOPMENT_LABEL = "Inviato con successo";
export const TOTAL_LABEL = "Totale";
export const INDICATORS_LABEL = "Indicatori";
export const COMMENTS_LABEL = "Commenti";
export const COMPLETED_TASKS = "Attività completate";
export const COMMENT_PC_LABEL = "Commento PC ";
export const COMMENT_BAM_LABEL = "Commento Business Area Manager ";
export const NOTE_CAREER_DEV_COMMITTEE_LABEL =
  "Note Career Development Committee";
export const FEEDBACK_COLLABORATOR_LABEL = "Feedback al collaboratore";
export const EMPTY_DEVELOPMENT_INDICATORS_MESSAGE =
  "Compila gli indicatori di sviluppo e segna le attività completate per monitorare il percorso del collaboratore";
export const EMPTY_DEVELOPMENT_INDICATORS_FOR_GRADE_MESSAGE =
  "Non sono previsti criteri di valutazione per questo collaboratore.";
export const EMPTY_COMMENTS_MESSAGE =
  "Definisci commenti PC, Business Area Manager, Career Development Committee e feedback per questo collaboratore";
export const ENACTED_BEHAVIOR_LABEL = "Comportamento Agìto";
export const NOT_ENACTED_LABEL = "Non agìto";
export const RARELY_ENACTED_LABEL = "Agìto raramente";
export const OFTEN_ENACTED_LABEL = "Agìto spesso";
export const FULLY_ENACTED_LABEL = "Agìto pienamente";
export const FILL_DEVELOPMENT_INDICATORS_MESSAGE_TOOLTIP =
  "Puoi compilare la sezione quando lo stato della scheda passa ad Avanzamento";
export const POTENTIAL_MATRIXV3_LABEL = "Matrice del Potenziale3";
export const MATRIX_DEVELOPMENT_LABEL = "Matrice Development";
export const MATRIX_PERFORMANCE_LABEL = "Matrice Performance";
export const MATRIX_GENERAL_LABEL = "Matrice Generale";
export const DISTRIBUTION_CHART_TITLE_LABEL =
  "Distribuzione per Internal Grade e potenziale";
export const PERCENTAGE_VIEW_LABEL = "Vista in percentuale";
export const START_DEVELOPMENT_COMMITTEE_LABEL = "Start Development Committee";
export const START_PERFORMANCE_COMMITTEE_LABEL = "Start Performance Committee";
export const QUADRANT_LABEL_HIGH_POTENTIAL = "High Potential";
export const QUADRANT_LABEL_GROWTH_POTENTIAL = "Growth Potential";
export const QUADRANT_LABEL_POTENTIAL_IN_CURRENT_ROLE =
  "Potential in current role";
export const QUADRANT_LABEL_ROLE_CONTEXT_NOT_ALIGNED =
  "Role/Context not aligned";
export const JUNIOR_CONSULTANT_LABEL = "Jr. Consultant";
export const CONSULTANT_LABEL = "Consultant";
export const SENIOR_CONSULTANT_LABEL = "Sr. Consultant";
export const MANAGER_LABEL = "Manager";
export const SENIOR_MANAGER_LABEL = "Sr. Manager";
export const CC_LEADER_LABEL = "CC Leader";
export const CC_MANAGER_LABEL = "CC Manager";
export const SPEAKER_LABEL = "SPEAKER";
export const PERFORMANCE_LABEL = "Performance";
export const BUSINESS_AREA_MANAGER_COMMENT_LABEL =
  "COMMENTO BUSINESS AREA MANAGER";
export const VALUTATION_MATRIX_OF_DEVELOPMENT_LABEL =
  "Matrice di valutazione del development";
export const INTERNAL_GRADE_PASS_LABEL = "Passaggio di Internal Grade";
export const CCNL_LEVELL_PASS_LABEL = "Passaggio di livello CCNL";
export const INCREASE_LABEL = "Aumento";
export const MODIFY_RESUME_DEVELOPMENT_PLAN_LABEL =
  "Modifica piano di sviluppo";
export const MODIFY_RESUME_DEVELOPMENT_PLAN_MESSAGE =
  "Sei sicuro di voler salvare le modifiche apportate al piano di sviluppo e avanzamento?";
export const INTERNAL_GRADE_START_LABEL = "Internal Grade di Partenza";
export const INTERNAL_GRADE_END_LABEL = "Internal Grade di Arrivo";
export const NO_DATA_CHART_LABEL = "Nessun dato presente";
export const YES_LABEL = "Sì";
export const NO_LABEL = "No";
export const TO_EVALUATE_LABEL = "Da valutare";
export const INTERNAL_GRADE_ADVANCEMENT_LABEL = "Passaggio di Internal Grade";
export const CCNL_LEVEL_ADVANCEMENT_LABEL = "Passaggio di Livello CCNL";
export const SALARY_ADVANCEMENT_LABEL = "Aumento";
export const INTERNAL_GRADE_ADVANCEMENT_DISABLED_MESSAGE =
  "Questo passaggio è disabilitato quando l'internal grade di arrivo e quello di partenza sono gli stessi";
export const CAREER_ADVANCEMENT_PROPOSAL_LABEL = "Proposta, passaggi e aumenti";
export const NO_SELECTION_LABEL = "Nessuna selezione";
export const DOWNLOAD_DISABLED_TOOLTIP_LABEL =
  "Download attivo solo in visualizzazione “Collaboratori”";
export const MATRIX_DEVELOPMENT_DOWNLOAD_TITLE_LABEL =
  "Matrice Development - Development Committee";
export const ALL_COLLABORATORS_LABEL = "Tutti i collaboratori";
export const ALL_COMPETENCE_CENTER = "Tutti i CC";
export const ERROR_NOT_SUPPORTED_SCREEN_LABEL = "Schermo non supportato";
export const ERROR_NOT_SUPPORTED_SCREEN_MESSAGE_LABEL =
  "Questa pagina è accessibile solo da schermi di dimensioni maggiori.";
export const MATRIX_PERFORMANCE_DOWNLOAD_TITLE_LABEL =
  "Matrice Performance - Development Committee";
